import * as React from 'react';
import { Route, Switch } from 'react-router-dom';

import EventquizList from './eventquiz-list.component';
import EventquizCreate from './eventquiz-create.component';
import EventquizView from './eventquiz-view.component';
import EventquizEdit from './eventquiz-edit.component';
import EventquizCopy from './eventquiz-copy.component';
import EventquizDelete from './eventquiz-delete.component';

interface Props {
  root?: string;
}

export const EventquizRoute: React.FunctionComponent<Props> = (props) => {

  return (
    <Switch>
      <Route path={(props.root||'') + '/eventquiz/create'} component={EventquizCreate} />
      <Route path={(props.root||'') + '/eventquiz/view'} component={EventquizView} />
      <Route path={(props.root||'') + '/eventquiz/edit'} component={EventquizEdit} />
      <Route path={(props.root||'') + '/eventquiz/copy'} component={EventquizCopy} />
      <Route path={(props.root||'') + '/eventquiz/delete'} component={EventquizDelete} />
      <Route path={(props.root||'') + '/eventquiz'} component={EventquizList} />
    </Switch>
  );
}
